import React, { PropsWithChildren } from 'react';

import { useSonTranslation } from '../../../translation/useSonTranslation';
import { FileUpload } from '../../FileUpload';
import { InputProps, SpanProps } from '../../../types/HtmlProps';

type ImageUploadProps = { labelTitle?: string; inputProps: InputProps; labelProps: SpanProps };
export function ImageUpload({ children, inputProps, labelTitle, labelProps }: PropsWithChildren<ImageUploadProps>) {
  const { t } = useSonTranslation('ImageUpload');

  return (
    <FileUpload labelTitle={labelTitle || t('buttons.chooseFile')} inputProps={inputProps} labelProps={labelProps}>
      {children}
    </FileUpload>
  );
}
